import styled from 'styled-components';

export const Heading = styled.div<HeadingProps>`
	font-weight: 500;
	font-size: ${props => (props.$fontSize ? props.$fontSize : '20px')};
	color: #222222;
	padding-bottom: 16px;
`;

export interface HeadingProps extends React.HTMLAttributes<HTMLDivElement> {
	$fontSize?: string;
}
